import { action, makeObservable, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { message } from "antd";
import {
	AMEND_QUOTE_MTA_API_URL,
	CALCULATE_QUOTE_MTA_API_URL,
	CALCULATE_QUOTE_AMEND_MTA_API_URL,
	CONFIRM_QUOTE_MTA_AMEND_API_URL,
	CONFIRM_QUOTE_MTA_API_URL,
	LOAD_QUOTE_FOR_MTA_API_URL,
	CALCULATE_QUOTE_VIEW_MODE
} from "../../configs/api-paths";
import BaseInsuranceCalculatorService from "../base/BaseInsuranceCalculatorService";


/**
 * Service dealing with insurance MTA.
 */

// if update is true, then we are updating the quote, otherwise we updating policy. Different API is used for each case.
// let _QUOTE_PATH = false;


class InsuranceMtaService extends BaseInsuranceCalculatorService {


	@observable
	insuranceForMta = null;

	constructor(props) {
		super(props);
		makeObservable(this);
	}

	@action
	setInsuranceForMta = (data) => {
		this.insuranceForMta = data;
	};


	loadInsuranceForMta = async (policyNumber, modeUpdatingQuote) => {
		let hideLoadingMessage = message.loading("Loading...", 0);

		try {
			let quote;
			if (modeUpdatingQuote) {
				//updating quote				
				/*  */

				const quoteId = policyNumber; //
				quote = await super.loadRequest(
					`${AMEND_QUOTE_MTA_API_URL}?quoteId=${quoteId}`
				);
			} else {
				// updating policy
				quote = await super.loadRequest(
					`${LOAD_QUOTE_FOR_MTA_API_URL}?policyNumber=${policyNumber}`
				);
			}

			this.setInsuranceForMta(quote);
			console.log("insuranceForMta", this.insuranceForMta)
			hideLoadingMessage();
		} catch (error) {
			console.log(error);

			hideLoadingMessage();
			message.error(
				`There was error while trying to load quote data from the server. Error: ${error}`
			);
		}
	};

	calculateInsuranceMta = async (modeUpdatingQuote, isViewMode) => {
		const insuranceForMta = this.insuranceForMta;

		this.setInsuranceForMta(null);

		let hideLoadingMessage = message.loading("Loading...", 0);

		try {
			const propsToSend = [
				"quoteId",
				"organisation",
				"organisation_name",
				"organisation_type",
				"pl_cover_amt",
				"pl_turnover",
				"el",
				"el_wageroll",
				"el_volunteer_staff",
				"equipment",
				"equipment_cover_amt",
				"uk_only",
				"ngb_qualified",
				"appropriate_training",
				"hazardous_materials",
				"risk_assessment",
				"participation_form",
				"safety_briefing",
				"correct_operation",
				"previous_claims",
				"insurance_declaration",
				"activityTrades",
				"startDate",
			];

			let API_URL;



			if (modeUpdatingQuote) {
				API_URL = CALCULATE_QUOTE_AMEND_MTA_API_URL;
				console.log("isViewMode from service", isViewMode)

				if (isViewMode) {
					console.log("test quote calculate")
					API_URL = CALCULATE_QUOTE_VIEW_MODE
				}

			} else {
				API_URL = CALCULATE_QUOTE_MTA_API_URL;
				if (isViewMode) {
					API_URL = CALCULATE_QUOTE_VIEW_MODE
				}
			}

			const result = await super.calculateRequest(
				API_URL,
				propsToSend,
				insuranceForMta
			);

			hideLoadingMessage();

			this.setInsuranceForMta(result);
		} catch (error) {
			console.log(error);
			this.setInsuranceForMta(insuranceForMta);

			hideLoadingMessage();
			message.error(
				`There was error while trying to send data to the server. Error: ${error}`
			);
		}
	};

	confirmInsuranceMta = async () => {

		try {
			const propsToSend = [
				"quoteId",
				"organisation",
				"organisation_name",
				"organisation_type",
				"startDate",
				"pl_cover_amt",
				"pl_turnover",
				"el",
				"el_wageroll",
				"el_volunteer_staff",
				"equipment",
				"equipment_cover_amt",
				"uk_only",
				"ngb_qualified",
				"appropriate_training",
				"hazardous_materials",
				"risk_assessment",
				"participation_form",
				"safety_briefing",
				"correct_operation",
				"previous_claims",
				"insurance_declaration",
				"activityTrades",
			];

			const quoteId_fix = this.insuranceForMta.amendedQuoteData.quoteId;

			const isPolicy = this.insuranceForMta.policyNumber;

			let CONFIRM_API;



			// we are calling different API for policy and quote when confirming payment at the end
			if (isPolicy) {
				CONFIRM_API = CONFIRM_QUOTE_MTA_API_URL; //for policy			
			} else {
				CONFIRM_API = CONFIRM_QUOTE_MTA_AMEND_API_URL; //for quote
			}

			const response = await super.confirmRequest(
				CONFIRM_API,		// CONFIRM_QUOTE_MTA_API_URL
				propsToSend,
				this.insuranceForMta,
				{ overThePhone: this.overThePhone },
				quoteId_fix
			);



			// const result = await response.json();
			const status = await response.status; // returns 200

			if (status === 200) {
				this.context.thankYouService.setThankYouData(status);

				// hideLoadingMessage();
				message.success(
					"Successfully sent data to the server. Thank you for your request."
				);

				return 'SUCCESS';

				// this.setInsuranceForMta(null);
			}
		} catch (error) {
			console.log(error);

			// hideLoadingMessage();
			message.error(
				`There was error while trying to send data to the server. Error: ${error}`
			);
		}
	};
}

export default InsuranceMtaService;
